import { ImagePlus, X } from "lucide-react";
import { useState } from "react";
import { useEffect } from "react";
import { FormInput } from "../../../helpers/AdminHelper";
import { GetImageUrl } from "../../../helpers/GetImageUrl";
import { memo } from "react";

const BannerSection = ({
  project,
  bannerAlt,
  updateProject,
  bannerImage,
  setBannerImage,
}) => {
  const preview = bannerImage
    ? URL.createObjectURL(bannerImage)
    : project.bannerImage
      ? GetImageUrl(project.bannerImage)
      : null;

  const handleBannerChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setBannerImage(file);
  };

  const removeBanner = () => {
    setBannerImage(null);
    updateProject("bannerImage", "");
  };
  return (
    <div className="space-y-4">
      <label className="text-sm text-slate-300">Project Banner</label>

      {preview ? (
        <div className="mt-2 relative h-56 rounded-xl border border-white/10 bg-white/5 overflow-hidden">
          <img
            src={preview}
            alt="Banner Preview"
            className="h-full w-full object-cover"
          />

          <button
            type="button"
            onClick={removeBanner}
            className="absolute top-2 right-2 h-8 w-8 rounded-full bg-red-500 text-white flex items-center justify-center"
          >
            <X size={16} />
          </button>
        </div>
      ) : (
        <label className="mt-2 h-56 rounded-xl border border-dashed border-white/20 bg-white/5 flex flex-col items-center justify-center cursor-pointer hover:bg-white/10 transition">
          <ImagePlus size={30} className="text-slate-400" />

          <span className="mt-2 text-sm text-slate-400">
            Upload Banner Image
          </span>

          <input
            type="file"
            hidden
            accept="image/*"
            onChange={handleBannerChange}
          />
        </label>
      )}

      <FormInput
        label="Banner Alt"
        placeholder="Security guards monitoring corporate office entrance"
        value={bannerAlt}
        onChange={(e) => updateProject("bannerAlt", e.target.value)}
      />
    </div>
  );
};

export default memo(BannerSection);
